module.exports = __webpack_public_path__ + "static/media/loading.235b9b3e.gif";